import styled from 'styled-components'
import { colors } from '../../assets/colors'

const Content = styled.span`
  font-size: 16px;
  color: ${colors.black};
`

export default Content
